import { Link } from 'react-router-dom';
import { processSteps } from '../data/process';

export function HowItWorksPage() {
  return (
    <div className="container how-page">
      <div className="page-hero how-page-hero">
        <span className="eyebrow">How It Works</span>
        <h1 className="how-page-title">
          <span className="how-page-title-line">From Discovery to Final Product</span>
          <span className="gradient-text how-page-title-line">a Process Built for You</span>
        </h1>
        <p>
          Bizi Office follows a simple five-step engagement path. Each stage has a clear purpose: Find the problem,
          strategize solutions, execute the plan, deliver excellence.
        </p>
        <div className="how-page-actions">
          <a className="btn btn-primary" href="/#contact">
            Start with a discovery call
          </a>
          <Link className="btn btn-ghost" to="/services">
            Browse services
          </Link>
        </div>
      </div>

      <section className="how-flow-section" aria-label="Business process flowchart">
        <div className="how-flow-intro">
          <h2>Engagement flowchart</h2>
          <p className="muted">Each step is tailored for your understanding and engagement.</p>
        </div>

        <ol className="how-flowchart">
          {processSteps.map((step, index) => (
            <li key={step.id} className="how-flow-item" id={step.id}>
              {index > 0 && (
                <div className="how-flow-connector" aria-hidden="true">
                  <span className="how-flow-line" />
                  <span className="how-flow-arrow material-symbols-outlined">arrow_downward</span>
                </div>
              )}

              <article className="card how-flow-node">
                <div className="how-flow-node-top">
                  <div className="how-flow-badge">
                    <span className="how-flow-number">{step.number}</span>
                    <span className="how-flow-label">Step {step.number}</span>
                  </div>
                  <h3>{step.title}</h3>
                  <p className="how-flow-summary">{step.summary}</p>
                </div>

                <div className="how-flow-body">
                  <p className="how-flow-description">{step.description}</p>

                  <div className="how-flow-details-box">
                    <ul className="how-flow-details">
                      {step.details.map((detail) => (
                        <li key={detail}>
                          <span className="material-symbols-outlined">check_circle</span>
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            </li>
          ))}
        </ol>

        <div className="how-flow-end card" aria-label="Outcome">
          <div className="how-flow-end-icon">
            <span className="material-symbols-outlined">rocket_launch</span>
          </div>
          <div>
            <h3>Live automation in your operations</h3>
            <p>
              By the end of the path you have working systems in production, a trained team, and a clear path to expand
              into the next highest-leverage process.
            </p>
          </div>
        </div>
      </section>

      <section className="card how-cta">
        <div>
          <span className="eyebrow">Ready when you are</span>
          <h2>Want this path for your team?</h2>
          <p>
            Book a free discovery call and we will map where busywork is costing you the most — then outline the first
            automation that can land inside a few weeks.
          </p>
        </div>
        <div className="how-cta-actions">
          <a className="btn btn-primary btn-lg" href="/#contact">
            Schedule a free consultation
          </a>
          <Link className="btn btn-ghost btn-lg" to="/marketplace">
            Or shop ready-made extensions
          </Link>
        </div>
      </section>
    </div>
  );
}
